import { render, staticRenderFns } from "./ConsultRecommend.vue?vue&type=template&id=1c271a20&scoped=true"
import script from "./ConsultRecommend.vue?vue&type=script&lang=js"
export * from "./ConsultRecommend.vue?vue&type=script&lang=js"
import style0 from "./ConsultRecommend.vue?vue&type=style&index=0&id=1c271a20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c271a20",
  null
  
)

export default component.exports